import { useSyncExternalStore } from 'react';

/** The 600px line the sleek layout switches to desktop at (`@[600px]`). */
const WIDE_QUERY = '(min-width: 600px)';

function canQuery(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

function subscribe(onChange: () => void): () => void {
  if (!canQuery()) return () => {};
  const query = window.matchMedia(WIDE_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function isWide(): boolean {
  return canQuery() && window.matchMedia(WIDE_QUERY).matches;
}

/** True on a desktop-wide viewport; follows resizes. */
export function useIsWideViewport(): boolean {
  return useSyncExternalStore(subscribe, isWide, () => false);
}
